import { post } from "@/api";
import type { LoginResponse } from "@/types";
import type { Login, SignUp } from "@/validation";

export function login(data: Login, backUrl?: string) {
  return post<LoginResponse>("/v1/login", { ...data, backUrl });
}

export function signUp(data: SignUp) {
  return post("/v1/user", data);
}
